import { getCookie, setCookie, deleteCookie } from 'cookies-next'

import { IS_TEST_ENV } from '@/config/constants'
import { getSharedCookieDomain } from '@/lib/utils/cookie-domain'

export const TOKEN_KEY = IS_TEST_ENV ? 'digen_token_test' : 'digen_token'

export const getToken = () => {
  return getCookie(TOKEN_KEY)?.toString() || ''
}

/**
 * 如果不设置过期时间，则cookie永久有效，而不是成为会话cookie
 */
export const setToken = (token: string, date?: string) => {
  const domain = getSharedCookieDomain()
  const options: Parameters<typeof setCookie>[2] = {
    expires: date ? new Date(date) : new Date('2099-12-31'),
    path: '/'
  }
  if (domain) {
    options.domain = domain
  }
  return setCookie(TOKEN_KEY, token, options)
}

export const removeToken = () => {
  const domain = getSharedCookieDomain()
  if (domain) {
    deleteCookie(TOKEN_KEY, { domain, path: '/' })
  }
  // rm_frontend 生产环境使用 domain=digen.ai（无点前缀）
  deleteCookie(TOKEN_KEY, { domain: 'digen.ai', path: '/' })
  // 同时删除 host-only cookie（Amplify 预览、本地开发、旧数据）
  deleteCookie(TOKEN_KEY, { path: '/' })
}
